import React, { PropsWithChildren } from 'react';
import { withTheme } from '@material-ui/core';

import { dataAttrsFromProps } from '../../internals/react-utils';

import { MenuItem } from './MenuItem.view';

import type { Theme } from '../../types/common.types';

import './style.css';

const MenuAction: React.FC<
  PropsWithChildren<{
    disabled?: boolean;
    label: string;
    onClick: () => void;
    title?: string;
    theme: Theme;
    testId?: string;
  }>
> = ({ children, disabled = false, label, onClick, title, theme, testId, ...rest }) => (
  <MenuItem>
    <button
      className="menu__action"
      disabled={disabled}
      title={title}
      style={{
        color: disabled ? theme.palette.action.disabled : theme.palette.text.primary,
      }}
      onClick={onClick}
      {...dataAttrsFromProps(rest)}
      data-testid={testId}
    >
      {label}
      {children}
    </button>
  </MenuItem>
);

// @ts-ignore
const Themed = withTheme(MenuAction);

export { Themed as MenuAction };
